import { ReactNode } from "react";

import {
  DashboardIcon,
  DotIcon,
  GeohashIcon,
  H3Icon,
  LineIcon,
  LookupIcon,
  MakerIcon,
  MapIcon
} from "@/assets/icons";
import { COUNTRY_NAME } from "@/constants/dataset";
import { CountryCode } from "@/types/common";
import { LayerType } from "@/types/map";

import { twMerge } from "tailwind-merge";

type SpatialInfo = {
  [key: string]: {
    icon: ReactNode;
    label: string;
    textColor: string;
  };
};

export const SPATIAL_INFO: SpatialInfo = {
  [LayerType.ADMINISTRATIVE]: {
    icon: <MapIcon className="fill-royal-blue w-[12px]" />,
    label: "Admin. Area",
    textColor: "text-royal-blue"
  },
  [LayerType.POLYGON]: {
    icon: <DashboardIcon className="fill-tangerine w-[12px]" />,
    label: "Polygon",
    textColor: "text-tangerine"
  },
  [LayerType.POINT]: {
    icon: <MakerIcon className="fill-blue-violet w-[12px]" />,
    label: "Point",
    textColor: "text-blue-violet"
  },
  [LayerType.GRID]: {
    icon: <LookupIcon className="fill-teal-500 size-3" />,
    label: "Grid",
    textColor: "text-blue-violet"
  },
  [LayerType.PROFILING]: {
    icon: <LookupIcon className="fill-teal-500 size-3" />,
    label: "Profiling",
    textColor: "text-blue-violet"
  },
  [LayerType.H3]: {
    icon: <H3Icon className="fill-teal-500 size-3" />,
    label: "H3",
    textColor: "text-teal-500"
  },
  [LayerType.GEOHASH]: {
    icon: <GeohashIcon className="size-3" />,
    label: "Geohash",
    textColor: "text-dim-gray"
  },
  [LayerType.LINE]: {
    icon: <LineIcon className="size-3 fill-purple-300" />,
    label: "Line",
    textColor: "text-dim-gray"
  }
};

type DatasetCardSpatialInfoProps = {
  spatialType: string;
  countryId?: CountryCode;
  rightContent?: React.ReactNode;
  areaRegion?: string;
};

export const DatasetCardSpatialInfo = ({
  spatialType,
  countryId,
  rightContent,
  areaRegion
}: DatasetCardSpatialInfoProps) => {
  const { icon, label, textColor } =
    SPATIAL_INFO[spatialType] || SPATIAL_INFO[LayerType.POLYGON];

  return (
    <div className="flex justify-between mt-1">
      <div className="flex items-center gap-1">
        {icon}
        <span className={twMerge("text-[10px]", textColor)}>{label}</span>

        <div className="flex items-center gap-1 px-2">
          <DotIcon className="fill-light-gray" />
          <span className="text-[10px] text-grey">
            {COUNTRY_NAME[countryId || "id"]}
          </span>
          {!!areaRegion && (
            <>
              <DotIcon className="fill-light-gray" />
              <span className="text-[10px] text-grey">{areaRegion}</span>
            </>
          )}
        </div>
      </div>

      {rightContent}
    </div>
  );
};
